/* tslint:disable */
export var icon = "\n<svg width=\"30\" height=\"46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 29.919C30 38.8 23.284 46 15 46 6.716 46 0 38.8 0 29.919 0 21.037 15 0 15 0s15 21.037 15 29.919z\"/></svg>\n";
//# sourceMappingURL=drop-small.svg.js.map